const { detect } = require('detect-browser');

export default function($log, $sce) {
  'ngInject';

  $log.debug('PDF Preview Comoponent Activated');

  const vm = this;
  const browser = detect();

  vm.getCurrentTime = () => `?time=${new Date().getTime()}`;
  vm.trustSrc = src => $sce.trustAsResourceUrl(src);

  // handle the case where we don't detect the browser
  switch (browser && browser.name) {
    case 'chrome':
    case 'firefox':
      vm.supported = true;
      break;

    default:
      vm.supported = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/pdfPreview/controller.js